import React, {FC} from 'react';

import {ChannelModel} from '../../../../../libs/shared/core/src/models/api/channelModel';
import {ConversationActionContextsEnum} from '../../../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {CellsContext} from '../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {TimelineVariationsEnum} from '../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {ActivityModel} from '../../../../models/api/activityModel';
import {SendingActivity} from '../../../../store/panels/viewer/viewerPanelSelectors';
import {SendingCommentViewerContainer} from './sending/sendingCommentViewerContainer';
import {SendingMessageViewerContainer} from './sending/sendingMessageViewerContainer';

/*
 * Props.
 */

export interface SendingActivityViewerProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  namespace: string;
  conversationId: number;
  conversationActionContext: ConversationActionContextsEnum | undefined;
  isSpam: boolean;
  replyChannel?: ChannelModel;
  sendingActivity: SendingActivity;
  previousSendingActivity?: SendingActivity;
  nextSendingActivity?: SendingActivity;
  isLastActivity?: boolean;
  lastActivity?: ActivityModel;
  lastOrphanSentMessageUid?: string;
  timelineVariation: TimelineVariationsEnum;
}

/*
 * Component.
 */

export const SendingActivityViewer: FC<SendingActivityViewerProps> = (props) => {
  const {sendingActivity, timelineVariation} = props;
  const {comment, message} = sendingActivity;

  if (comment) {
    return (
      <SendingCommentViewerContainer {...props} comment={comment} timelineVariation={timelineVariation} />
    );
  }

  if (message) {
    return (
      <SendingMessageViewerContainer
        {...props}
        messageUid={message.uid}
        timelineVariation={timelineVariation}
      />
    );
  }

  throw new Error('A sending activity should have a comment or a message');
};
